import React from 'react';
import { Box, Typography, Tooltip, IconButton } from '@mui/material';
import TravelExploreIcon from '@mui/icons-material/TravelExplore';
import CloseIcon from '@mui/icons-material/Close';

const PRIMARY = '#f25d27';
const MAX_TOOLTIP_ITEMS = 5;

/**
 * Chip compacto exibido na barra de chips do composer, resumindo quantos
 * itens de um grupo de contexto (ex.: "Sugestões NeoFeed", "Notícias
 * relacionadas") estão selecionados. Clicar no corpo reabre o modal de
 * contexto naquela aba; o X limpa toda a seleção daquele grupo.
 *
 * @param {{
 *   icon?: React.ReactNode;
 *   label: string;
 *   count: number;
 *   items?: string[];
 *   onClick?: () => void;
 *   onClear?: () => void;
 * }} props
 */
export default function ContextSummaryChip({ icon, label, count, items = [], onClick, onClear }) {
    const visibleItems = items.slice(0, MAX_TOOLTIP_ITEMS);
    const remaining = items.length - visibleItems.length;

    const tooltipTitle = items.length > 0 ? (
        <Box sx={{ py: 0.3 }}>
            {visibleItems.map((item, idx) => (
                <Typography key={idx} sx={{ fontSize: '0.72rem', lineHeight: 1.5 }}>
                    {item}
                </Typography>
            ))}
            {remaining > 0 && (
                <Typography sx={{ fontSize: '0.72rem', lineHeight: 1.5, opacity: 0.8 }}>
                    e mais {remaining}
                </Typography>
            )}
        </Box>
    ) : '';

    return (
        <Tooltip title={tooltipTitle} placement="top" arrow>
            <Box
                onClick={onClick}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 0.5,
                    px: 1,
                    py: 0.4,
                    borderRadius: '8px',
                    backgroundColor: `${PRIMARY}0c`,
                    border: `1px solid ${PRIMARY}30`,
                    maxWidth: '100%',
                    cursor: onClick ? 'pointer' : 'default',
                }}
            >
                {icon || <TravelExploreIcon sx={{ fontSize: 13, color: PRIMARY, flexShrink: 0 }} />}
                <Typography sx={{
                    fontSize: '0.72rem',
                    color: PRIMARY,
                    fontWeight: 600,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    flex: 1,
                    minWidth: 0,
                }}>
                    {count} {label}
                </Typography>
                {onClear && (
                    <Tooltip title={`Limpar seleção de ${label.toLowerCase()}`}>
                        <IconButton
                            size="small"
                            onClick={(e) => { e.stopPropagation(); onClear(); }}
                            sx={{ p: 0.2, color: PRIMARY, flexShrink: 0 }}
                        >
                            <CloseIcon sx={{ fontSize: 13 }} />
                        </IconButton>
                    </Tooltip>
                )}
            </Box>
        </Tooltip>
    );
}
